import { Settings } from 'luxon';

export default ({ store }) => {
  Settings.defaultLocale = store.state.global ? store.state.global.locale : store.state.locale;
};
